import { useTheme, useMediaQuery } from '@mui/material'

export function useIsMobile() {
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'))
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const isMobileDialog = useMediaQuery(theme.breakpoints.down('sm'))
  return { isTablet, isMobile, isMobileDialog }
}
